// Plandan Üretim Fişi Oluştur penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.createOrdersFromPlan';

export const productionCreateOrdersFromPlanGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Plandan üretim fişi nasıl oluşturulur?'),
  intro: t(`${G}.intro`, 'Planlamada seçtiğiniz ürünler için tek seferde taslak üretim fişleri açarsınız. Fişler taslak olduğu için stok henüz değişmez; stok fiş tamamlanınca değişir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Üretim fişi oluştur'),
    body: t(`${G}.regions.body`, 'Depolar, tarih, satırlar'),
    footer: t(`${G}.regions.footer`, 'Vazgeç / Oluştur'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Depoları ve tarihi seçin'),
      text: t(`${G}.s1.text`, '"Girdi deposu" malzemelerin tamamlamada düşeceği, "Çıktı deposu" mamulün gireceği depodur. İlk değer planlamada seçtiğiniz depodan (yoksa varsayılan depodan) gelir. "Üretim tarihi" seçili satırların en erken ihtiyaç tarihiyle (yoksa bugünle) gelir. Burada yaptığınız seçim tüm satırlara uygulanır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Satırları kontrol edin'),
      text: t(`${G}.s2.text`, 'Her seçili ürün için bir satır vardır; "Miktar" plandaki öneriyle (değiştirdiyseniz sizin değerinizle) gelir ve burada da düzeltilebilir. Miktar sıfırdan büyük olmalıdır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Bir ürünün deposu ya da tarihi farklı olacaksa "Satır depoları"na basın; her satırın altında kendi girdi deposu, çıktı deposu ve üretim tarihi açılır.'),
        t(`${G}.s2.tip2`, 'Tek seferde en fazla 100 satır için fiş oluşturulabilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Oluşturun ve sonucu açın'),
      text: t(`${G}.s3.text`, '"Seçilenler için üretim fişi oluştur (n)" düğmesine basın. Sonuçta her ürünün yanında açılan fiş numarası (tıklayınca fiş açılır) ya da neden açılamadığı yazar. "Planı yeniden hesapla" planı yeniden hesaplar; yeni taslak fişler, parametrelerde "Taslak üretim fişleri" işaretliyse hesaba girer.'),
      tips: [
        t(`${G}.s3.tip1`, 'Fişler reçeteden hesaplanan girdilerle taslak olarak açılır; malzemeleri kontrol edip fiş sayfasından tamamlarsınız.'),
      ],
    },
  ],
});
